import React from 'react';
import ReactToPrint from 'react-to-print';
class inLanDongLaiXemTruoc extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _html: "",
        };

    }
    //   static getDerivedStateFromProps(nextProp, prevState) {
    //     let { data } = nextProp;
    //     let { choVayId } = prevState;
    //     if (data && data.ChoVayId && data.ChoVayId !== choVayId) {
    //       return { choVayId: data.ChoVayId };
    //     }
    //     return null;
    //   }

    componentDidMount() {
        let { data } = this.props;
        this.setState({_html: data.current.outerHTML});
    }
    render() {
        return (
            <div>
                <ReactToPrint
                    trigger={() => (
                        <button
                            type="button"
                            className="btn btn-new-main btn-checknew disk-mobile"
                        >
                            <span >
                                <i className="mdi mdi-printer"></i>
                            </span>
                             &nbsp;In danh sách  &nbsp;
                        </button>
                    )}
                    content={() => this.componentRef}
                    copyStyles={false}
                />
                <div style={{ display: 'none' }}>
                    <div ref={(el) => (this.componentRef = el)}>
                        <div
                            style={{ width: '100%', color: '#000000', padding: '10px' }}
                            dangerouslySetInnerHTML={{ __html: this.state._html }}
                        ></div>
                    </div>
                </div>
            </div>
        );
    }
}
export default inLanDongLaiXemTruoc;
